import React, { useContext } from "react";
import {
  Container,
  Typography,
  Box,
  Avatar,
  Paper,
  Stack,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { Navigate } from "react-router-dom";
import { UserContext } from "../../contexts/userContext";
import { alpha, useTheme } from "@mui/material/styles";

const AuthWrapper = ({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) => {
  const userContext = useContext(UserContext);
  const theme = useTheme();

  if (userContext.loading) return <div />;
  if (userContext.user.id !== "") return <Navigate to="/" />;

  return (
    <Box
      sx={{
        bgcolor: "background.default",
        height: "100vh",
        overflow: "auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
        py: 4,
      }}
    >
      <Container component="main" maxWidth="xs" sx={{ mb: 5 }}>
        <Paper
          elevation={0}
          sx={{
            p: 4,
            borderRadius: 4,
            mt: 4,
            backgroundColor: alpha(theme.palette.background.paper, 0.9),
            border: "2px solid",
            borderColor: "divider",
            backdropFilter: "blur(6px)",
          }}
        >
          <Stack spacing={3} alignItems="center">
            <Typography variant="h4" fontWeight="bold">
              SjorCraft
            </Typography>

            <Avatar sx={{ bgcolor: "secondary.main", width: 56, height: 56 }}>
              <LockOutlinedIcon fontSize="large" />
            </Avatar>

            <Typography component="h1" variant="h5">
              {title}
            </Typography>

            {children}
          </Stack>
        </Paper>
      </Container>
    </Box>
  );
};

export default AuthWrapper;
